<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Просмотр') }}</h1>
    <div class="my-organization">
      <div class="bso-reports hunters-pg create bgw-pdg-20">
        <div class="tab-main">
          <v-tabs
            v-model="tabHunters"
            background-color="transparent"
            color="#333"
            slider-color="transparent"
          >
            <v-tab>{{ $t('Данные охотника') }}</v-tab>
            <v-tab>{{ $t('Охотоудостоверения') }}</v-tab>
            <v-tab>{{ $t('Сведения об аттестации') }}</v-tab>
            <v-tab>{{ $t('Животные') }}</v-tab>
            <v-tab-item class="pb-2">
              <ul class="info-list">
                <li>
                  <label>{{ $t('ФИО') }}:</label>
                  <strong>{{ hunter.fio }}</strong>
                </li>
                <li><label>{{ $t('Дата рождения') }}:</label> {{ hunter.birthDate }}</li>
                <li><label>{{ $t('Пол') }}:</label> {{ hunter.genderName }}</li>
                <li><label>{{ $t('Гражданство') }}:</label> {{ hunter.countryName }}</li>
                <li v-if="hunter.country === KyrgyzstanCountry">
                  <label>{{ $t('ПИН') }}:</label> {{ hunter.pin }}
                </li>
                <li>
                  <label>{{ hunter.country === KyrgyzstanCountry ? $t('ID-карта') : $t('Номер паспорта') }}:</label> {{ hunter.passport }}
                </li>
                <li v-if="hunter.country === KyrgyzstanCountry">
                  <label>{{ $t('Кем выдан') }}:</label> {{ hunter.issuedBy }}
                </li>
                <li v-if="hunter.country !== KyrgyzstanCountry">
                  <label>{{ $t('Данные разрешенного оружия') }}:</label> {{ hunter.weaponData }}
                </li>
                <li><label>{{ $t('Телефон') }}:</label> {{ hunter.phone }}</li>
                <li><label>{{ $t('Адрес') }}:</label> {{ hunter.address }}</li>
              </ul>
            </v-tab-item>
            <v-tab-item class="pb-2">
              <TicketModal v-bind:tickets.sync="tickets" :editable="false" :hunterId="hunter.id"/>
            </v-tab-item>
            <v-tab-item class="pb-2">
              <CertificateModal v-bind:certificates.sync="certifications" :editable="false" :hunterId="hunter.id"/>
            </v-tab-item>
            <v-tab-item class="pb-2">
              <AnimalModal v-bind:animals.sync="animals" :editable="false" :hunterId="hunter.id"/>
            </v-tab-item>
          </v-tabs>
        </div>
        <!--Кнопки действии-->
        <div class="form-action text-center">
          <button
            class="btn btn-default blue"
            type="button"
            @click="onEdit"
          >
            {{ $t('Редактировать') }}
          </button>
          <button
            class="btn btn-default gray"
            type="button"
            @click="onCancel"
          >
            {{ $t('Отмена') }}
          </button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import CertificateModal from '@/components/hunter/CertificateModal'
import Hunters from '@/model/hunters'
import TicketModal from '@/components/hunter/TicketModal'
import AnimalModal from '@/components/hunter/AnimalModal'

export default {
  components: {
    TicketModal,
    CertificateModal,
    AnimalModal
  },
  data: () => ({
    breadcrumbs: [],
    tabHunters: null,
    hunter: {},
    KyrgyzstanCountry: null,
    certifications: [],
    tickets: [],
    animals: []
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      Hunters.getInfo(this.$route.params.id).then((response) => {
        this.hunter = response.data.ooptHunter
        this.tickets = response.data.tickets
        this.certifications = response.data.certifications
        this.animals = response.data.animals
        this.KyrgyzstanCountry = response.data.KyrgyzstanCountry
        this.generateBreadcrumbs()
        this.setLoading(false)
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'hunters-list'
      })
    },
    // Переход на страницу создания
    onEdit () {
      this.$router.push({
        name: 'hunter-edit',
        params: {
          id: this.$route.params.id
        },
        query: {
          tabHunters: this.tabHunters
        }
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Охотники'),
          disabled: false,
          href: '/hunters-list'
        },
        {
          text: this.$i18n.t('Просмотр'),
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
